import { Label as HeadlessUILabel } from "@headlessui/react";
import tw, { styled } from "twin.macro";

export const StyledLabel = styled.span(
  tw`block text-sm font-medium leading-6 text-gray-900`
);

const Label = StyledLabel.withComponent(HeadlessUILabel);

export default Label;
